<template>
  <div class="sidebar">
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <centered-loader v-if="loading" />

      <b-list-group width="20px" class="list-group">
        <b-form-select
          v-model="imagesStatus"
          :options="imagesStatusList"
        ></b-form-select>
        <b-list-group-item class="nav">
          <b-button
            title="Выход"
            size="sm"
            variant="outline-light"
            class="exit"
            @click="logout"
          >
            <b-icon icon="door-closed" name="exit"></b-icon>&nbsp;
            <span>Выход</span>
          </b-button>
          <b-button
            size="sm"
            variant="outline-light"
            class="exit"
            @click="toGetAct()"
          >
            <span v-if="!this.displayActs">Список актов просмотра</span>
            <span v-else>Закрыть список актов</span>
          </b-button>
        </b-list-group-item>
        <div v-if="layers && layers.length > 0 && !this.displayActs">
          <b-list-group-item>
            <div class="buttons-wraper">
              <b-checkbox v-model="selectAll"> Выделить все снимки </b-checkbox>
              <b-button-group class="buttons" size="sm">
                <b-button
                  @click="downloadImg(layers)"
                  variant="outline"
                  style="background-color: #4185f4"
                >
                  <b-icon icon="arrow-clockwise" animation="spin" v-if="this.gridloading" name="loading"></b-icon>
                  <span  v-if="!this.gridloading" class="btn-title" style="color: white">{{
                    "Скачать KML (сетки)"
                  }}</span>
                </b-button>
              </b-button-group>
            </div>
          </b-list-group-item>
          <b-list-group-item
            button
            v-for="(layer, index) in layers"
            :key="index"
          >
            <div class="image-item">
              <div @click.prevent="selectLayer(layer)">
                <b-checkbox v-model="layer.selected" />
              </div>
              <span
                :class="layer.visible ? null : 'collapsed'"
                :aria-expanded="layer.visible ? 'true' : 'false'"
                aria-controls="collapse"
                @click="setActiveLayer(layer)"
              >
                {{ layer.date }}
              </span>
            </div>
            <div v-if="activeLayer">
              <b-collapse
                v-model="layer.visible"
                v-for="(image, index) in activeLayer.image"
                :key="index"
                v-bind:id="'image_' + index"
                class="panel-collapse collapse"
              >
                <div class="image-item">
                  <div>
                    <b-checkbox v-model="image.selected" />
                  </div>
                  <div
                    style="
                      display: flex;
                      flex-direction: row;
                      align-items: center;
                      width: 89%;
                    "
                    @click.self="handleClick(image, index, layers)"
                  >
                    <img
                      class="preview"
                      :title="image.code"
                      :src="`${image.quicklook_url}`"
                      @click.self="handleClick(image, index, layers)"
                      alt
                    />
                    <div class="buttons-wrapper">
                      <span
                        :title="image.code"
                        class="title"
                        @click.self="handleClick(image, index, layers)"
                      >
                        {{ image.code }}
                      </span>
                      <b-badge
                        v-if="image.status === 'private'"
                        variant="danger"
                        >Не допущен</b-badge
                      >
                      <b-badge
                        v-if="image.status === 'public'"
                        variant="success"
                        >Допущен</b-badge
                      >
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-list-group-item>
          <div class="footer-button">
            <b-button @click="$bvModal.show('bv-modal')" variant="outline">
              <span class="btn-title" style="color: white">{{
                "Загрузить KML (сетки)"
              }}</span>
            </b-button>
            <b-modal id="bv-modal" title="Загрузить файл">
              <div class="d-block text-center">
                <form enctype="multipart/form-data" novalidate>
                  <div class="dropbox">
                    <input
                      type="file"
                      multiple
                      :name="files"
                      @change="
                        filesChange($event.target.name, $event.target.files)
                      "
                      accept="application/zip"
                      class="input-file"
                    />
                  </div>
                </form>
              </div>
              <template #modal-footer>
                <div class="w-100">
                  <b-button
                    variant="success"
                    size="md"
                    class="float-left"
                    @click="uploadFiles()"
                  >
                    <span class="btn-title">{{ "Загрузить" }}</span>
                  </b-button>
                  <b-button
                    variant="primary"
                    size="md"
                    class="float-right"
                    @click="$bvModal.hide('bv-modal')"
                  >
                    <span class="btn-title">{{ "Отмена" }}</span>
                  </b-button>
                </div>
              </template>
            </b-modal>
          </div>
        </div>
        <!-- <div v-if="imagesStatus==='private'"> -->
        <!-- | private
        </div> -->
        <div v-else-if="!this.displayActs">
          <b-list-group-item class="list-item header">
            Снимки отсутствуют
          </b-list-group-item>
        </div>
        <b-button
                    variant="primary"
                    size="md"
                    class="float-left"
                    style="position:relative"
                    @click="generateAct()"
                     v-if="displayActs"
                  >
                    <span class="btn-title">{{ "Создать акт" }}</span>
          </b-button>
        <div v-if="displayActs" class="act-list">
          <b-card-body
            class="act-card"
            v-for="(act, index) in this.acts"
            :key="index"
          >
            Акт просмотра от
            {{ act.created_at.slice(0, 10).split("-").reverse().join(".") }}
            <br />
            <b-button @click="toDownloadAct(act.id, act.name)"
              >Скачать акт</b-button
            >
          </b-card-body>
        </div>
      </b-list-group>
    </transition>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <logs ref="logs" />
    </transition>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Logs from "@/components/logs/Logs";
import axios from "axios";
import {
  WidthType,
  BorderStyle,
  Document,
  Paragraph,
  Packer,
  TextRun,
} from "docx";
import { saveAs } from "file-saver";
import { visibility } from "../Buttonhide.js";
var tokml = require("tokml");
const { promisify } = require("util");

export default {
  components: {
    Logs,
    Document,
    Paragraph,
    Packer,
    TextRun,
    saveAs,
    BorderStyle,
    WidthType,
  },
  props: ["displayActions"],
  data() {
    return {
      gridloading: false,
      displayActs: false,
      selected: [],
      selectedItem: null,
      // selectAll: false,
      files: null,
      editedIndex: -1,
      loading: true,
      uploadedFiles: [],
      uploadError: null,
      images: [],
      showDismissAlert: false,
      showSuccessAlert: true,
      imagesStatusList: [
        { value: "undefined", text: "Снимки для просмотра" },
        { value: "others", text: "Просмотренные снимки" },
      ],
      visible: true,
      activeLayer: null,
      acts: [],
    };
  },
  watch: {
    layers: function (val) {
      this.loading = false;
    },
    "$root.displaybuttons": function (val) {
      this.activeLayer = null
      for (var i = 0; i < 20; i++) {
        if (document.getElementById("image_" + i)) {
          document.getElementById("image_" + i).style.background = "transparent";
        } else {
          break;
        }
      }
    },
  },
  computed: {
    ...mapGetters(["layers"], "showButtons"),

    selectAll: {
      get: function () {
        return this.layers ? this.selected.length == this.layers.length : false;
      },
      set: function (value) {
        var selected = [];

        if (value) {
          this.layers.forEach(function (layer) {
            layer.selected = true;
            layer.image.forEach((el) => (el.selected = true));
            for (let i = 0; i < layer.image.length; i++) {
              selected.push(layer.image[i].id);
            }
          });
        } else {
          this.layers.forEach(function (layer) {
            layer.selected = false;
            layer.image.forEach((el) => (el.selected = false));
          });
        }

        this.selected = selected;
      },
    },
    imagesStatus: {
      get: function (value) {
        localStorage.images = "show";
        return "undefined";
      },
      set: function (value) {
        this.displayActs = false;
        if (value) {
          if (value === "undefined") {
            this.$root.displaybuttons = true;
            this.getLayers();
          } else {
            this.getLayersByStatus(value);
            this.$root.displaybuttons = false;
          }
          this.selected = [];
          this.selectAll = false;
        }
      },
    },
  },
  methods: {
    ...mapActions([
      "private",
      "notPrivate",
      "logout",
      "uploadShp",
      "getLayers",
      "downloadAct",
      "getLayersByStatus",
      "getGrid",
    ]),
    generateDoc(props) {
      let doc = new Document();
      doc.addParagraph(
        new Paragraph(`Detailed Report for ${this.state.name}`).title().center()
      );
      let title = new Paragraph(`Detailed Report for ${this.state.name}`)
        .title()
        .center();
      let packer = new Packer();
      packer.toBlob(doc).then((blob) => {
        saveAs(blob, "detailed_report.docx");
        toast({
          type: "success",
          title: "Document created!",
        });
      });
    },
    handleClick(layer, key, total) {
      for (var i = 0; i < 20; i++) {
        if (!document.getElementById("image_" + i)) {
          break;
        }
        document.getElementById("image_" + i).style.background = "transparent";
      }
      document.getElementById("image_" + key).style.background = "lightblue";
      this.editedIndex = this.selected.indexOf(layer.id);
      if (layer.selected === false) {
        layer.selected = true;
        this.selectComputations(layer);
        // this.getGrid(layer.id)
        this.eventBus.$emit("layerClicked", layer);

        // this.eventBus.$emit("setLayer", layer);
      } else {
        if (this.editedIndex != -1) {
          this.selected.splice(this.editedIndex, 1);
          this.editedIndex = -1;
        }
        layer.selected = false;
        this.eventBus.$emit("layerClicked", null);
      }
    },
    selectComputations(layer) {
      if (layer.selected) {
        if (this.selected.length > 0) {
          if (!(this.selected.indexOf(layer.id) != -1)) {
            this.selected.push(layer.id);
          }
        } else {
          this.selected.push(layer.id);
        }
      }
    },

    downloadItems(layers) {
      // if (this.selected.length!=0) {
      //   window.location.href = `${process.env.VUE_APP_BASE_URL}/api/v1/images/zip?ids=${this.selected}`;
      // } else {
      //   return this.$bvModal
      //   .msgBoxConfirm(
      //     "Пожалуйста, выберите снимки",
      //     {
      //       buttonSize: "md",
      //       title: "Подтверждение",
      //       okVariant: "success",
      //       okTitle: "Ok",
      //       cancelTitle: "Отмена",
      //       footerClass: "p-2",
      //       hideHeaderClose: false,
      //       centered: true
      //     }
      //   )
      //   .catch(err => {
      //     console.log(err);
      //   });
      // }
    },
    async downloadImg(l) {
      this.$root.curLayer = undefined
      // window.location.href = `${process.env.VUE_APP_BASE_URL}/api/v1/images/${this.currentLayer.id}/download`
      this.$root.globalgrid_temp = [];
      this.gridloading = true
      var tempgrid = [];
      l[0].image.forEach(async (j) => {
        if (j.selected) {
          this.$root.concealgrid = true
          const res = await this.getGrid(j.id,true).then(() => {
            this.$root.globalgrid.forEach((e) => {
              tempgrid.push(JSON.parse(JSON.stringify(e)));
            });
          });
        }
      });
      this.showGrid = false;
      var forConv = {
        type: "FeatureCollection",
        features: tempgrid,
      };
      setTimeout(() => {
        setTimeout(() => {
          this.gridloading = false
          this.kmlfile = tokml(forConv);
          const url = window.URL.createObjectURL(
            new Blob([this.kmlfile], { type: "application/xml" })
          );
          const link = document.createElement("a");
          link.href = url;
          const date = new Date();
          link.setAttribute(
            "download",
            `grid_${date.getDate()}-${
              date.getMonth() + 1
            }-${date.getFullYear()}.kml`
          );
          document.body.appendChild(link);
          link.click();
        }, this.$root.globalgrid.length*5)
      }, 3000)
    },

    filesChange(fieldName, fileList) {
      if (!fileList.length) return;
      this.images = fileList;
    },
    uploadFiles() {
      this.uploadShp(this.images);

      return this.$bvModal.hide("bv-modal");
    },
    generateAct(){
        axios({
        url: `${process.env.VUE_APP_BASE_URL}/api/v1/acts/generate`,
        method: 'POST',
        headers: {
              'Authorization': `Bearer ${JSON.parse(sessionStorage.token)}`
            },
        responseType: 'blob', // important
      }).then((e) => {
        this.toGetAct()
        this.displayActs = true
      })
    },
    toGetAct() {
      this.displayActs = !this.displayActs;
      axios({
        url: `${process.env.VUE_APP_BASE_URL}/api/v1/acts/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${JSON.parse(sessionStorage.token)}`,
        },
        // responseType: 'blob', // important
      })
        .then((response) => {
          console.log(response.data);
          this.acts = response.data.reverse();
          // response.data.forEach
          // const url = window.URL.createObjectURL(new Blob([response.data]));
          // const link = document.createElement('a');
          // link.href = url;
          // link.setAttribute('download', 'file.txt');
          // document.body.appendChild(link);
          // link.click();
        })
        .catch(function (error) {
          console.log(error);
        });
      // this.generateDoc(1)
    },
    async toDownloadAct(id, name) {
      const res = await axios.get(
        `${process.env.VUE_APP_BASE_URL}/api/v1/acts/{id}/download?act_id=${id}`,
        {
          headers: {
            Authorization: `Bearer ${JSON.parse(sessionStorage.token)}`,
          },
          responseType: "blob",
        }
      );
      console.log(res);
      const url = window.URL.createObjectURL(res.data);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", name);
      document.body.appendChild(link);
      link.click();
      console.log(res.data);
    },
    setActiveLayer(data) {
      this.activeLayer = data;
      console.log(data)
      this.layers.forEach((e) => {
        if (JSON.stringify(data) !== JSON.stringify(e)){
        e.visible = false
        }
      })
      data.visible = !data.visible;
    },

    selectLayer(layer) {
      layer.selected = !layer.selected;
      layer.image.forEach((img) => {
        if (layer.selected) {
          img.selected = true;
        } else {
          img.selected = false;
        }
      });
    },
  },

  inject: ["eventBus"],
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700");
.sidebar {
  position: absolute;
  top: 0;
  left: 0;
  width: 25%;
  height: 95%;
  background-color: white;
  border-right: 1px solid black;
  min-width: 300px;
  z-index: 2;
  overflow-y: scroll;
}

.list-group {
  border-radius: 0 !important;
}

.list-item {
  display: flex !important;
  flex-direction: column;
  text-align: center;
}

.title {
  margin-bottom: 10px;
  font-size: small;
  overflow-wrap: break-word;
}

.secret-button {
  text-align: center;
  display: flex;
  justify-content: space-between;
}

.btn-title {
  margin: auto;
}

.buttons {
  text-align: center;
  width: 100%;
  display: flex !important;
  justify-content: space-between;
}

.header {
  display: flex;
  justify-content: center;
  font-family: "Poppins", "Calibri", sans-serif;
}
.send {
  position: sticky;
  bottom: 0;
  width: 100%;
  text-align: center;
  z-index: 1000;
}

.list-group-item-action:hover {
  background-color: lightgray;
}
.list-group-item-action:focus {
  color: --light-blue !important;
  background-color: #64b5f6;
}

.preview {
  width: 60px;
  height: 60px;
  border: 2px solid #4185f4;
  border-radius: 50%;
  margin-right: 20px;
}
.image-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.buttons-wrapper {
  overflow: hidden;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.footer-button {
  background-color: #4185f4;
  position: fixed !important;
  bottom: 0px;
  height: 5%;
  width: 25%;
  text-align: center;
  min-width: 300px;
  min-height: 40px;
}
.nav {
  background-color: #4185f4 !important;
  color: white;
  font-family: Arial, Helvetica, sans-serif;
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;
}
.clear {
  position: absolute;
  right: 20px;
}
.active:focus {
  outline-color: #4185f4;
  outline-style: none;
}
.act-list {
  background: white;
  right: 42px;
  margin: 10px;
  max-height: 90vh;
}
.act-list > div {
  margin: 5px 0;
}
.act-card {
  border: 2px solid black;
  color: black;
  background: white;
  max-width: 100%;
  white-space: pre-wrap;
}
</style>
